
const texts = {
  errorMessages: {
    completarEmailDuplicado: 'EF009: El correo ya fue cargado. No podés agregar el mismo correo dos veces.',
    completarCuitValido: 'EF0010: El número de CUIL/CUIT no es válido.',
    completarCampo: 'EF0011: Completar todos los campos obligatorios.',
    completarCuitNoGuiones: 'EF0012: Escribí el número de CUIL/CUIT sin guiones ni puntos.',
    completarEmailValido: 'EF0013: Escribí un correo electrónico válido.',
    completarCuitDuplicado: 'EF0014: Ese CUIL/CUIT ya está cargado. No podés agregar la misma persona dos veces.',
  },
  input: {
    name: 'Nombre*',
    nameAccesible: 'Nombre',
    lastname: 'Apellido*',
    lastnameAccesible: 'Apellido',
    email: 'Correo Electrónico*',
    emailAccesible: 'Correo Electrónico',
    cuitCuil: 'CUIL*',
    cuitAccesible: 'Cuil',
  },

};

export default texts;
